<template>
	<div class="contractain">
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<span v-if="this.$route.query.state == 1">我的预审合同</span>
			<span v-if="this.$route.query.state == 2">我的合同</span>
			<span v-if="this.$route.query.state == 3">我的续租订单</span>
			<span v-if="this.$route.query.state == 5">合同帮助</span>
			<div style="font-size: 0.75rem;"></div>
		</div>
		<div style="width: 100%; height: 1.9375rem;"></div>
		<!-- 预审合同 -->
		<div v-if="this.$route.query.state == 1">
			<div v-if="contractlist == undefined" style="height: 60px; line-height: 60px; color: #666; font-size: 0.875rem;">暂无合同~</div>
			<div v-else>
				<div class="block" v-for="(item,index) in contractlist" :key="index" @click="goTo(item.order_number,1,item.id)">
					<div class="withinblock">
						<div class="top">
							<img src="../../assets/getset.png" />
							<div>
								<div style="font-size: 0.9rem;">{{item.title}}</div>
								<div class="number">订单编号：{{item.order_number}}</div>
							</div>
						</div>
						<div class="bottom">
							<div>
								<div>合同状态</div>
								<div class="state">未签订</div>
							</div>
							<div>
								<div>合同含税金额</div>
								<div class="money">{{item.total}}元</div>
							</div>
							<div>
								<div>签订日期</div>
								<div class="tiem">{{item.time}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 正式合同 -->
		<div v-if="this.$route.query.state == 2">
			<div v-if="contractlists == undefined" style="height: 60px; line-height: 60px; color: #666; font-size: 0.875rem;">暂无合同~</div>
			<div v-else>
				<div class="block" v-for="(item,index) in contractlists" :key="index" @click="goTo(item.order_number,2)">
					<div class="withinblock">
						<div class="top">
							<img src="../../assets/formal.png" />
							<div>
								<div style="font-size: 0.9rem;">{{item.title}}</div>
								<div class="number">合同编号：{{item.number}}</div>
							</div>
						</div>
						<div class="bottom">
							<div>
								<div>合同状态</div>
								<div class="state" v-if="item.sign == 0">未签订</div>
								<div class="state" v-if="item.sign == 1">已签订</div>
								<div class="state" style="background-color:#eee;" v-if="item.sign == 2">已终止</div>
							</div>
							<div>
								<div>合同含税金额</div>
								<div class="money">{{item.total}}元</div>
							</div>
							<div>
								<div>签订日期</div>
								<div class="tiem">{{item.time}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 我的账单 -->
		<div v-if="this.$route.query.state == 3">
			<div style="height: 60px; line-height: 60px; color: #666; font-size: 0.875rem;">暂无订单~</div>
			<!-- 	<div class="block">
				<div class="withinblock">
					<div class="top" style="justify-content: space-between;">
						<div style="margin-left: 0;">第1期 续租账单</div>
						<div style="margin-left: 0; color: #F1452F;">待支付</div>
					</div>
					<div class="bottom">
						<div>
							合同编号：JBJ20201126-A00012
						</div>
						<div>
							账单周期：2021-11-26至2022-11-26
						</div>
						<div>
							<div style="font-size: 20px; color: #F1452F; font-weight: bold;">￥260.0</div>
							<div class="buttom" style="background-color: #F1452F;">去支付</div>
						</div>
					</div>
				</div>
			</div> -->
		</div>
		<div class="withinblock" v-if="this.$route.query.state == 5">
			<div class="sterw" v-html="content"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				contractlist: '', //预审合同
				contractlists: '', //正式合同
				content: ''
			}
		},
		created() {
			this.getinvoicelist();
			this.contractHelp();
		},
		methods: {
			// 合同预览 
			goTo(e, i, id) {
				this.$router.push({
					path: '/contractPreview',
					query: {
						order_number: e,
						type: i,
						id: id
					}
				})
			},
			// 获取信息
			getinvoicelist() {
				this.$axios.post(baseUrl + '/mobile/order/contractList', {
					token: localStorage.getItem('Authorization'),
				}).then((res) => {
					if (res.data.code == 1) {
						this.contractlist = res.data.data.ys
						this.contractlists = res.data.data.zs
					} else {
						this.contractlist = undefined
						this.contractlists = undefined
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			// 获取帮助
			contractHelp() {
				this.$axios.post(baseUrl + '/mobile/order/contractHelp').then(res => {
					this.content = res.data.data.content
				}).catch((err) => {
					console.log(err);
				});
			},
			// 合同信息下载
			tocontract(e) {
				var tex;
				if (this.active == 0) {
					tex = 1
				} else {
					tex = 2
				};
				this.$axios.post(baseUrl + '/mobile/order/contract', {
					order_number: e,
					token: localStorage.getItem('Authorization'),
					type: tex
				}).then(res => {
					if (res.data.data == "yes") {
						BSL.OpenWeb('https://backstage.jbj-china.com.cn/mobile/order/topdf?order_number=' + e + '&type=' +
							tex)
					} else {
						this.$dialog.confirm({
								title: '您还没有填写您的合同信息',
								confirmButtonText: '去填写',
								confirmButtonColor: '#F1452F',
							})
							.then(() => {
								this.$router.push({
									path: '/contract',
									query: {
										order_number: e
									}
								})
							})
							.catch(() => {
								// on cancel
							});
					}
				});
			},
		}
	}
</script>

<style scoped>
	.contractain .titou {
		width: 89%;
		height: 3rem;
		margin: auto;
		display: flex;
		justify-content: space-between;
		font-size: 1rem;
	}

	.contractain .titou>div {
		margin-top: 0.85rem;
	}

	.contractain .titou .arr {
		font-size: 0.875rem;
		color: #666;
		position: relative;
		top: 0.25rem;
	}

	.contractain .block {
		background-color: #fff;
		width: 100%;
		padding: 1rem 0;
		margin-bottom: 0.625rem;
	}

	.contractain .block:last-child {
		margin-bottom: 0;
	}

	.contractain .withinblock {
		width: 89%;
		margin: auto;
		font-size: 0.8rem;
	}

	.contractain .top img {
		display: block;
		width: 2.5rem;
		height: 2.5rem;
		border-radius: 0.125rem;
	}

	.contractain .top {
		display: flex;
		text-align: left;
		padding-bottom: 0.6rem;
		border-bottom: 1px solid #eee;
	}

	.contractain .top>div {
		margin-left: 0.625rem;
	}

	.contractain .bottom {
		margin-top: 0.625rem;
		font-size: 0.875rem;
	}

	.contractain .bottom>div {
		display: flex;
		justify-content: space-between;
		height: 1.6rem;
		line-height: 1.6rem;
	}

	.contractain .number {
		font-size: 0.7rem;
		color: #666;
		margin-top: 0.1875rem;
	}

	.contractain .state {
		color: #F1452F;
	}

	.contractain .money {
		font-size: 1.125rem;
	}

	.contractain .tiem {
		color: #666;
		font-size: 0.875rem;
		margin-top: 0.125rem;
	}

	.contractain .buttom {
		padding: 0 0.9375rem;
		background-color: #CCCCCC;
		line-height: 1.625rem;
		border-radius: 999px;
		color: #fff;
	}

	.contractain .icon {
		display: inline-block;
		width: 0.9375rem;
		height: 0.9375rem;
		position: relative;
		top: 3px;
	}

	.sterw>>>img {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/contractain/contractain.vue